// ─────────────────────────────────────────────────────────────────────────────
// Analytics page — Platform Analytics. This component only wires things
// together:
//     • useAnalyticsData — one parallel fetch pass over ten endpoints, each of
//       the optional eight failing on its own so a dead endpoint dims one tile
//       instead of blanking the page
//   All rendering lives in ./components, formatting in ./format.js and the
//   payload→chart transforms in ./buildAnalytics.js.
//
// Reaching this page already requires analytics access (RequireModule + the
// sidebar), and nothing here writes, so there is no per-control RBAC gate.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./Analytics.module.css";
import { useAnalyticsData } from "./hooks/useAnalyticsData";
import AnalyticsHeader from "./components/AnalyticsHeader";
import StatsRow from "./components/StatsRow";
import ChartCard from "./components/ChartCard";
import LineChart from "./components/LineChart";
import BarChart from "./components/BarChart";
import TopNodesTable from "./components/TopNodesTable";
import RegionsCard from "./components/RegionsCard";

export default function Analytics() {
  const data = useAnalyticsData();
  const { loading, activity, nodeUsage, traffic, topNodes, regions } = data;

  return (
    <div className={styles.page}>
      <div className={styles.pageShell}>
        <AnalyticsHeader />

        <div className={styles.pageContent}>
          <StatsRow loading={loading} data={data} />

          <div className={styles.chartsRow}>
            <ChartCard>
              <LineChart data={activity} loading={loading}
                label="User Activity" tooltipLabel="Activity users" />
            </ChartCard>

            <ChartCard>
              <BarChart data={nodeUsage} loading={loading} />
            </ChartCard>

            <ChartCard>
              <LineChart data={traffic} loading={loading}
                label="Traffic Trend (GB)" tooltipLabel="GB" />
            </ChartCard>
          </div>

          <div className={styles.bottomRow}>
            <TopNodesTable rows={topNodes} loading={loading} />
            <RegionsCard regions={regions} loading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
}
